import styled from 'styled-components';

const LoginTop = styled.div`
    background: #031c30;
    padding: 15px 65px 5px;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    color: #eff0f3;
`;

export default LoginTop;



// WEBPACK FOOTER //
// ./app/containers/Login/components/LoginTop/index.js